import { createFileRoute } from "@tanstack/react-router";
import BundleAnalyzerPage from "@/pages/BundleAnalyzerPage";

export const Route = createFileRoute("/tools/bundle-analyzer")({
  component: BundleAnalyzerPage,
});
